import { Container, Row, Col, Button, Form } from "react-bootstrap";
import { useState, useEffect } from "react";
import "../../../App.css";
import "../../../css/bootstrap.scss";
import reg_entity from "../../../images/create_entity_ques1_icon1.png";
import arrow_left from "../../../images/arrow-left.png";
import countriesData from "../../../data/countries.json";
import countriesStateData from "../../../data/states.json";
import BackButton from "../../Includes/BackButtonEntityAccount";
import { Field, reduxForm, InjectedFormProps } from "redux-form";
import renderField from "../../renderField";
import { connect } from "react-redux";
import {
  setEmail,
  setwizardPageNumber,
  setwizardPageName,
  setUserID,
  setEntityAccountUserDetails,
  setEntityAccountBusinessDetails,
} from "../../EntityAccountReducer";
import { RootState } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { ToastBox, notifyError, notifySuccess } from "MyComponents/Toaster";
import config from "../../../config";
import axios, { AxiosError } from "axios";
import { Dropdown } from "primereact/dropdown";
import Spacer from "MyComponents/UI/Spacer";
import { updateEntityKycDraftStep } from "Utils/entityKycDraft";
import { useTranslation } from "react-i18next";

interface Props { }
interface FormData {
  businessEntityName: string;
  businessWebsiteName: string;
  noWebsite: boolean;
}

const CreateEntitySecondQues: React.FC<
  Props & InjectedFormProps<{}, Props, FormData>
> = (props: any) => {
  const { handleSubmit } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const page = useSelector(
    (state: RootState) => state.entityAccount.wizardPageNumber
  );
  const entityAccountUserDetails = useSelector(
    (state: RootState) => state.entityAccount.entityAccountUserDetails
  );

  const _entityAccountBusinessDetails = useSelector(
    (state: RootState) => state.entityAccount.entityAccountBusinessDetails
  );
  const userID = useSelector((state: RootState) => state.entityAccount.userID);
  const userBusinessName = entityAccountUserDetails.entityBusinessName || entityAccountUserDetails.businessName;

  const [validated, setValidated] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    dispatch(setwizardPageName("eligibilityB"));
  }, [dispatch]);

  const [selectedCountry, setSelectedCountry] = useState<any>(() => {
    const raw = _entityAccountBusinessDetails?.businessCountry;
    if (typeof raw === "string") {
      try {
        return JSON.parse(raw);
      } catch (e) {
        return "";
      }
    }
    return raw || "";
  });

  const options = countriesData.map((country) => ({
    name: country.name,
    image: country.image,
  }));

  const BusinessNatureListing = [
    "Agriculture",
    "Construction",
    "Consulting",
    "E-commerce",
    "Education",
    "Energy & Utilities",
    "Entertainment & Media",
    "Financial Services",
    "Healthcare",
    "Hospitality",
    "IT / Software",
    "Manufacturing",
    "Non-profit / NGO",
    "Real Estate",
    "Retail",
    "Service",
    "Telecommunications",
    "Trading",
    "Transportation & Logistics",
    "Wholesale",
    "Other",
  ];

  useEffect(() => {
    if (props.initialValues?.businessCountry) {
      const raw = props.initialValues.businessCountry;
      if (typeof raw === "string") {
        try {
          setSelectedCountry(JSON.parse(raw));
        } catch (e) {
          setSelectedCountry({ name: raw });
        }
      } else {
        setSelectedCountry(raw);
      }
    }
  }, [props.initialValues?.businessCountry]);

  useEffect(() => {
    if (props.initialValues?.businessWebsiteName === "None" || props.initialValues?.noWebsite) {
      setIsChecked(true);
    } else if (props.initialValues?.businessWebsiteName) {
      setIsChecked(false);
    }
  }, [props.initialValues?.businessWebsiteName, props.initialValues?.noWebsite]);

  const handleCheckboxChange = (e: any) => {
    setIsChecked(e.target.checked);
  };

  const submitForm = async (formValues: any) => {
    const { businessEntityName, businessCountry, businessState, businessNature, businessWebsiteName } = formValues;

    const businessDetailsObject = {
      businessLegalEntityName: businessEntityName,
      businessCountryOfRegistration: businessCountry,
      businessStateOfRegistration: businessState,
      natureOfBusiness: businessNature,
      businessWebsite: businessWebsiteName || (isChecked ? "None" : ""),
    };

    try {
      if (userID) {
        await updateEntityKycDraftStep(userID, 'EntityAccountUser', businessDetailsObject);
      }
      dispatch(setEntityAccountBusinessDetails({
        businessEntityName,
        businessCountry,
        businessState,
        businessNature,
        businessWebsiteName: businessWebsiteName || (isChecked ? "None" : ""),
      }));
      dispatch(setwizardPageNumber(page + 1));
      localStorage.setItem('pageNumber', `${page + 1}`);
    } catch (error) {
      console.error("Draft update error:", error);
      notifyError("Failed to save progress.");
    }
  };

  const countryOptionTemplate = (option: any) => {
    return (
      <div className="flex align-items-center">
        {option.image && (
          <img
            src={option.image}
            alt={option.name}
            style={{ width: "20px", marginRight: "5px" }}
          />
        )}
        {option.name}
      </div>
    );
  };

  const countryValueTemplate = (option: any, props: any) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <img
            alt={option.name}
            src={option.image}
            style={{ width: "20px", marginRight: "5px" }}
          />
          {option.name}
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  return (
    <Container fluid className="min-vh-custom mt-5 px-0 px-md-3">
      <Row className="g-0">
        <Col md={12} className=" text-center">
          <img src={reg_entity} width={50} />
          <h3 className="text-center mt-3">
            {t('kyc.business_kind_q', { name: userBusinessName })}
          </h3>
          <span className="text-secondary">
            {t('kyc.business_kind_desc')}
          </span>

          <Row className="justify-content-center">
            <Col md={10} className="text-start p-3 rounded-4 my-4">
              <Form noValidate={true} onSubmit={handleSubmit(submitForm)}>
                <Row className="mb-2 row">
                  <Col md={6} className="mb-3">
                    <label className="form-label fw-bold ">
                      {t('kyc.business_legal_entity_name')}
                    </label>

                    <Field
                      name="businessEntityName"
                      type="text"
                      component={renderField}
                      className="form-control rounded-5"
                      placeholder={t('kyc.type_business_legal_entity')}
                      id="businessEntityName"
                    />
                  </Col>
                  <Col md={6} className="mb-3">
                    <label className="form-label fw-bold ">
                      {t('kyc.business_country_reg')}
                    </label>

                    <Field
                      name="businessCountry"
                      component={({ input, meta }: any) => (
                        <>
                          <Dropdown
                            {...input}
                            value={input.value || selectedCountry}
                            onChange={(e) => {
                              input.onChange(e.value);
                              setSelectedCountry(e.value);
                            }}
                            options={options}
                            optionLabel="name"
                            placeholder="Select a Country"
                            filter
                            valueTemplate={countryValueTemplate}
                            itemTemplate={countryOptionTemplate}
                            className={`w-full md:w-14rem w-100  p-2 text-start px-3  border rounded-5 bg-white text-secondary ${meta.touched && meta.error ? 'border-danger' : ''}`}
                          />
                          {meta.touched && meta.error && <p className="text-danger small mt-1 ps-2 mb-0 fw-bold">{meta.error}</p>}
                        </>
                      )}
                    />
                  </Col>
                </Row>
                <Row className="mb-2 row">
                  <Col md={6} className="mb-3">
                    <label className="form-label fw-bold">
                      {t('kyc.business_state_reg')}
                    </label>
                    <Field
                      name="businessState"
                      component={({ input, meta }: any) => (
                        <>
                          <Dropdown
                            {...input}
                            value={input.value}
                            onChange={(e) => input.onChange(e.value)}
                            options={
                              selectedCountry
                                ? countriesStateData.find(
                                    (country) => country.name === (selectedCountry.name || selectedCountry)
                                  )?.states || []
                                : []
                            }
                            optionLabel="name"
                            optionValue="name"
                            placeholder="Select State"
                            filter
                            className={`w-full md:w-14rem w-100 p-2 text-start px-3 border rounded-5 bg-white text-secondary mt-1 ${
                              meta.touched && meta.error ? "border-danger" : ""
                            }`}
                          />
                          {meta.touched && meta.error && (
                            <p className="text-danger small mt-1 ps-2 mb-0 fw-bold">
                              {meta.error}
                            </p>
                          )}
                        </>
                      )}
                    />
                  </Col>

                  <Col md={6} className="mb-3">
                    <label className="form-label fw-bold ">{t('kyc.nature_of_business')}</label>

                    <Field
                      name="businessNature"
                      component={({ input, meta }: any) => (
                        <>
                          <Dropdown
                            {...input}
                            value={input.value}
                            onChange={(e) => input.onChange(e.value)}
                            options={BusinessNatureListing}
                            placeholder={t('kyc.select_nature')}
                            filter
                            className={`w-full md:w-14rem w-100 p-2 text-start px-3 border rounded-5 bg-white text-secondary mt-1 ${
                              meta.touched && meta.error ? "border-danger" : ""
                            }`}
                          />
                          {meta.touched && meta.error && (
                            <p className="text-danger small mt-1 ps-2 mb-0 fw-bold">
                              {meta.error}
                            </p>
                          )}
                        </>
                      )}
                    />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md={12}>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <Field
                        name="noWebsite"
                        component={({ input }: any) => (
                          <Form.Check
                            {...input}
                            checked={isChecked}
                            onChange={(e) => {
                              input.onChange(e.target.checked);
                              handleCheckboxChange(e);
                            }}
                            className="text-secondary"
                            label={
                              <span className="text-secondary small">
                                {t('kyc.no_website')}
                              </span>
                            }
                          />
                        )}
                      />
                    </div>

                    {!isChecked && (<>
                      <label className="form-label fw-bold mt-2">{t('kyc.business_website')}</label>
                      <Field
                        name="businessWebsiteName"
                        type="text"
                        component={renderField}
                        className="form-control rounded-5"
                        placeholder={t('kyc.type_website')}
                        id="businessWebsiteName"
                      />
                    </>
                    )}
                  </Col>
                </Row>
                <Row className="d-flex px-3 mt-4">
                  <Col md={12} className="text-end">
                    <Button type="submit" className="btn btn-primary rounded-5">
                      {t('common.continue')}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

const mapStateToProps = (state: RootState) => ({
  initialValues: {
    businessEntityName: state.entityAccount.entityAccountBusinessDetails.businessEntityName || "",
    businessCountry: state.entityAccount.entityAccountBusinessDetails.businessCountry || "",
    businessState: state.entityAccount.entityAccountBusinessDetails.businessState || "",
    businessNature: state.entityAccount.entityAccountBusinessDetails.businessNature || "",
    businessWebsiteName: state.entityAccount.entityAccountBusinessDetails.businessWebsiteName || "",
    noWebsite: false,
  },
});

const validate = (values: any) => {
  const errors: any = {};
  if (!values.businessEntityName) {
    errors.businessEntityName = 'Business Entity Name is required';
  }

  if (!values.businessCountry) {
    errors.businessCountry = 'Country is required.';
  }

  if (!values.businessState) {
    errors.businessState = 'State is required.';
  }

  if (!values.businessNature) {
    errors.businessNature = 'Business nature is required.';
  }

  if (!values.noWebsite) {
    if (!values.businessWebsiteName) {
      errors.businessWebsiteName = 'Website name is required.';
    } else {
      const urlPattern = new RegExp('^(https?:\\/\\/)?' +
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,})' +
        '(\\/[-a-z\\d%_.~+]*)*' +
        '(\\?[;&a-z\\d%_.~+=-]*)?' +
        '(\\#[-a-z\\d_]*)?$', 'i');
      if (!urlPattern.test(values.businessWebsiteName)) {
        errors.businessWebsiteName = 'Invalid website URL.';
      }
    }
  }

  return errors;
};

const form = reduxForm<{}, Props, FormData>({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  form: "entityWizard",
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  validate,
})(CreateEntitySecondQues);

export default connect(mapStateToProps)(form);
